import React, { useEffect, useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { getDecodedToken, logEvents, trackEvent } from "../../utils/functions";
import { observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ProfileStore2 from "../../store/ProfileStore2";
import PerformanceStore from "../../store/PerformanceStore";
import { homePageRoute, HOME_PAGE } from "../../utils/constants";

const Home = observer(() => {
  const location = useLocation();
  const pathname = location.pathname;

  useLayoutEffect(() => {
    AuthStore.updateLoadingFullScreen(true);
  }, []);

  useEffect(() => {
    trackEvent(HOME_PAGE);
    logEvents(HOME_PAGE);
  }, []);

  useEffect(() => {
    const pathArray = pathname?.split("/");
    AuthStore.updateLoadingFullScreen(true);

    if (UserStore.isHydrated) {
      if (pathArray.length === 2) {
        AuthStore.updateLoadingFullScreen(true);
        window.scrollTo(0, 0);
        UserStore.changeIsLiveToZero("0", false);
        UserStore.setNormalHybirdFlow(false);
        UserStore.removeInfinity();
        UserStore.updateHomeLoading(true);
        PerformanceStore.setCurrentLoader("fullScreen");

        if (getDecodedToken()?.user_type === "manager") {
          UserStore.getLiasionDetailsAndImage();
        }

        if (getDecodedToken()?.user_type !== "manager") {
          UserStore.getFamilyClients(
            "forImg",
            (data) => {
              const { user_id } = UserStore.userData;
              const usersId = !UserStore.isSelectedUserPrimary
                ? user_id
                : UserStore.selectedUsersId;

              const { profile_pic } = data.find(
                (user) => user.user_id == usersId
              );
              ProfileStore2.getImage(profile_pic ? profile_pic : "", "normal");
            },
            () => {}
          );
        }
        UserStore.populateHomeScreen();
      } else if (pathArray[2] === "instrument") {
      } else if (pathArray[2] === "subassetclassdetailsinfiniity") {
      } else if (pathArray[2] === "subassetclassdetailshome") {
      }
    }
    // eslint-disable-next-line
  }, [UserStore.isHydrated, location]);

  useEffect(() => {
    return () => {
      AuthStore.updateLoadingFullScreen(true);
      PerformanceStore.setLoaderClosingCheck({});
    };
  }, []);

  return (
    <>
      <Outlet context={{ type: homePageRoute }} />
    </>
  );
});

export default Home;
